import React, { useEffect, useState } from 'react';
import './public/site.css';
import logo from './logo.png';
import StoreBadges from './public/StoreBadges';
import { APP_STORE_URL, PLAY_STORE_URL } from './public/siteConfig';

function isIOS(): boolean {
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  if (
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  ) {
    return true;
  }
  return false;
}

function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent || '');
}

const Download: React.FC = () => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    document.title = 'Tải app Fconnect';
    if (isIOS()) {
      window.location.replace(APP_STORE_URL);
      return;
    }
    if (isAndroid()) {
      window.location.replace(PLAY_STORE_URL);
      return;
    }
    setShowFallback(true);
  }, []);

  return (
    <div className="fc-site fc-download">
      <div className="fc-download-card">
        <img src={logo} alt="Fconnect" className="footer-logo" />
        {showFallback ? (
          <>
            <p>Truy cập từ máy tính — vui lòng mở liên kết trên điện thoại hoặc chọn cửa hàng:</p>
            <StoreBadges />
          </>
        ) : (
          <>
            <div className="fc-spinner" aria-hidden="true" />
            <p>Đang chuyển đến cửa hàng ứng dụng…</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Download;
